import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import { Typography, lighten } from "@material-ui/core"
import { Link } from "gatsby"

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#282828",
    color: "#ffffff",
    padding: theme.spacing(2),
    borderRadius: 4,
    display: "inline-block",
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "45%",
    "&:hover": {
      backgroundColor: lighten("#282828", 0.05),
    },
  },
  title: {
    color: "#ffb192",
  },
  description: {
    color: "#bcbcbc",
  },
}))

const RelatedGuide = ({ title, description, link }) => {
  const classes = useStyles()
  return (
    <Link to={link}>
      <div className={classes.root}>
        <Typography variant="h6" className={classes.title} gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" className={classes.description} paragraph>
          {description}
        </Typography>
      </div>
    </Link>
  )
}

RelatedGuide.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}

export default RelatedGuide
